import StickyPageHeader from '../components/common/StickyPageHeader';
import PasswordChangePanel from '../components/panels/PasswordChangePanel';
import Layout from '../layout';

const AdminPasswordPage = ({ routes }) => {
  return (
    <>
      <StickyPageHeader isAdmin title="Settings / Update Password" />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <PasswordChangePanel id="password" title="Change Admin Password" />
      </Layout>
    </>
  );
};

export default AdminPasswordPage;
